export enum Status {
    PendingBooking = 'pendingBooking',
    Accepted = 'accepted',
    Active = 'active',
    Declined = 'declined',
    Cancelled = 'cancelled',
    Pending = 'pending',
    Completed = 'completed',
    PendingCompletion = 'pendingCompletion',
}

export enum ServiceType {
    Cleaning = 'cleaning',
    Catering = 'catering',
    Alcohol = 'alcohol',
    Workshop = 'workshop',
    Wellness = 'wellness',
    Other = 'other',
}

export enum Permissions {
    ReadAndWrite = 'readAndWrite',
    ReadOnly = 'readOnly',
    Disabled = 'disabled',
}

export enum WeekDays {
    Monday = 'monday',
    Tuesday = 'tuesday',
    Wednesday = 'wednesday',
    Thursday = 'thursday',
    Friday = 'friday',
    Saturday = 'saturday',
    Sunday = 'sunday',
}
